import request from '@/plugin/axios'

// 赛事列表
export function matchList(data) {
  return request({
    url: '/base/xg/match/list',
    method: 'get',
    params: data
  })
}
// 赛事详情
export function matchInfo(data) {
  return request({
    url: '/base/xg/match/info/' + data,
    method: 'get'
  })
}
// 赛事下拉菜单选项
export function getMatchDropdown() {
  return request({
    url: '/base/xg/match/matchDropdown/',
    method: 'get'
  })
}
// 记录赛事访问
export function recordMatchVisit(id) {
  return request({
    url: '/base/xg/match/recordMatchVisit/' + id,
    method: 'post'
  })
}
// 编辑赛事
export function matchEdit(data) {
  return request({
    url: '/base/xg/match/update',
    method: 'post',
    data
  })
}
// 新建赛事
export function matchAdd(data) {
  return request({
    url: '/base/xg/match/save',
    method: 'post',
    data
  })
}
// 赛事删除
export function matchDel(data) {
  return request({
    url: '/base/xg/match/delete',
    method: 'post',
    data
  })
}
// 赛事上下线
export function matchOnline(data) {
  return request({
    url: '/base/xg/match/online',
    method: 'post',
    data
  })
}
// app支付
export function matchApp(data) {
  return request({
    url: '/base/xg/match/appToPay',
    method: 'post',
    data
  })
}
// 赛次列表
export function roundList(data) {
  return request({
    url: '/base/xg/round/list',
    method: 'get',
    params: data
  })
}
// 赛次删除
export function roundDel(data) {
  return request({
    url: '/base/xg/round/delete',
    method: 'post',
    data
  })
}
// 新建赛次
export function roundAdd(data) {
  return request({
    url: '/base/xg/round/save',
    method: 'post',
    data
  })
}
// 编辑赛次
export function roundEdit(data) {
  return request({
    url: '/base/xg/round/update',
    method: 'post',
    data
  })
}
// 集鸽列表
export function collectList(data) {
  return request({
    url: '/base/xg/collectPigeon/list',
    method: 'get',
    params: data
  })
}
// 成绩列表
export function gradeList(data) {
  return request({
    url: '/base/xg/roundScore/list',
    method: 'get',
    params: data
  })
}
// 天气列表
export function weatherList(data) {
  return request({
    url: '/match/roundWeather/list',
    method: 'get',
    params: data
  })
}
// 天气列表
export function coordDetails(data) {
  return request({
    url: '/match/roundWeather/coordDetails',
    method: 'get',
    params: data
  })
}
// 天气列表修改
export function editCoord(data) {
  return request({
    url: '/match/roundWeather/editCoord',
    method: 'post',
    data
  })
}
// // 天气列表修改
// export function weatherEdit2(data) {
//   return request({
//     url: '/base/xg/trainingWeather/save',
//     method: 'post',
//     data
//   })
// }
// 天气重置
export function weatherReset(data) {
  return request({
    url: '/base/xg/weather/reset',
    method: 'post',
    data
  })
}
// 天气重置
export function weatherReset2(data) {
  return request({
    url: '/base/xg/trainingWeather/reset',
    method: 'post',
    data
  })
}
// 章程列表
export function constitutionList(data) {
  return request({
    url: '/base/xg/match/getConstitution',
    method: 'get',
    params: data
  })
}
// 奖金列表
export function bonusList(data) {
  return request({
    url: '/base/xg/bonus/list',
    method: 'get',
    params: data
  })
}
// 奖金列表修改
export function bonusEdit(data) {
  return request({
    url: '/base/xg/bonus/save',
    method: 'post',
    data
  })
}
